import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseReviewContractProps {
  publicCompanyLeadId?: string
  state?: string
  onSuccess: () => void
  onError: () => void
}

export const useReviewContract = ({ publicCompanyLeadId, state, onSuccess, onError }: UseReviewContractProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewContract'],
    mutationFn: async (data?: { description?: string }) => {
      const lead = {
        contract_attributes: {
          last_review_attributes: {
            state,
            description: data?.description,
          },
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
